module.exports = __webpack_public_path__ + "img/chbank.5bb2cc3f.png";